import { Task } from '../models';

export function splitTasks(tasks: Task[]) {
  if (tasks.length === 0) {
    return { moduleIds: [], closeModuleId: '' };
  }

  const moduleIds = tasks
    .filter((t) => !t.isCloseModule)
    .map((t) => t.moduleId);
  const closeModuleId = tasks.find((t) => t.isCloseModule)?.moduleId || '';
  return { moduleIds, closeModuleId };
}
